export default __webpack_public_path__ + "static/media/agm-white-logo.997a11df.png";